import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEXFApproval } from '../../../../hooks/useEPFERF';
import { IEXFRemarksForm } from '../utils/types';
import { EXFRemarksInitialValue, EXFRemarksSchema } from '../utils/schema';
import AppTextField from '../../../../components/common/forms/AppTextField';
import AppDialog from '../../../../components/common/AppDialog';
import LoadingIndicator from '../../../../components/common/LoadingIndicator';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

const ApprovalForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const status = location.pathname.split('/')[3];
  const exfApproval = useEXFApproval();

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<IEXFRemarksForm>({
    defaultValues: EXFRemarksInitialValue,
    mode: 'onChange',
    resolver: yupResolver(EXFRemarksSchema),
  });

  const handleClose = () => navigate('/my-equipment-requests/my-exf', { replace: true });

  const onSubmit = (formData: IEXFRemarksForm) => {
    exfApproval.mutate(formData);
  };

  if(exfApproval.isLoading) return <LoadingIndicator show />;

  return (
    <AppDialog 
      open 
      onDialogClose={handleClose} 
      title={status === 'approve' ? 'Approve EXF' : 'Reject EXF'} 
      maxWidth='sm' 
      titleAlignment="center"
    >
      <Stack component='form' height='100%' bgcolor='white' py={3} borderRadius={1}>
        <Stack px={3} height='100%' overflow='auto' gap={5}>
          <Stack direction='column' width="100%" justifyContent='center' margin='auto' gap={3}>
            <AppTextField
              label="EXF EM Remarks"
              labelPosition="top"
              labelAlignment="left"
              labelWidth='100%'
              fieldWidth= '100%'
              fontWeight={400}
              multiline
              rows={3}
              error={!!errors.exfEMRemarks}
              helperText={errors.exfEMRemarks?.message}
              {...register('exfEMRemarks')}
            />
            <Stack direction="row" justifyContent="center" gap={1}>
              <Button 
                variant="contained"
                onClick={handleSubmit(onSubmit)}
                disabled={!isValid} 
                sx={{ width:"100px" }}
              >
                Save
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </AppDialog>
  );
}

export default ApprovalForm;